__turbopack_context__.v({
  "btn": "NodeList-module-scss-module__DIIQTG__btn",
  "collapse": "NodeList-module-scss-module__DIIQTG__collapse",
  "list": "NodeList-module-scss-module__DIIQTG__list",
  "noteContainer": "NodeList-module-scss-module__DIIQTG__noteContainer",
  "noteContainer_close": "NodeList-module-scss-module__DIIQTG__noteContainer_close",
  "text": "NodeList-module-scss-module__DIIQTG__text",
  "title": "NodeList-module-scss-module__DIIQTG__title",
});
